App.Phone = DS.Model.extend
  number : DS.attr 'string'

  purged: (->
    "#{@get('number')}".replace(/[^+\d]/g,'')
  ).property('number')
